import React from 'react'
import MonucksProject from './Monucks/projectsVerbindung.js';
const projectsMonucks = () =>(
<MonucksProject />
)
export default projectsMonucks;



// WEBPACK FOOTER //
// ./src/projects/monucks.js